import { createContext } from 'react';

export const NetWorthWorkflowContext = createContext<any>({
  netWorthData: {},
  setNetWorthData: () => {},
});
